import Vue from 'vue'

//import messages from 'vee-validate/dist/locale/sr_Latin';

import messages from '../lang/sr/sr_Latin';
// Lib imports
import VeeValidate, { Validator } from 'vee-validate'

VeeValidate.Validator.localize('sr_Latin', messages);

const config = {
    locale: 'sr_Latin',
};

Vue.use(VeeValidate, config);
